import { BASE_HANDLER_URL } from "..";
import { DEFAULT_GRID_INFO_CLIENT_NOTE } from "../../Components/ClientDetail/ClientNote/KendoClientDetailNote";
import { DEFAULT_GRID_INFO_CLIENT_USER } from "../../Components/ClientDetail/ClientUser/KendoClientDetailUser";
import { DEFAULT_GRID_INFO_CLIENT_KIOSK } from "../../Components/ClientDetail/Configurations/Child/JotForm/KendoKioskFormGrid";
import { DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM } from "../../Components/ClientDetail/Configurations/Child/JotForm/KendoPatientFormGrid";
import { DEFAULT_GRID_INFO_CLIENT_TRAINING } from "../../Components/ClientDetail/ProjectPlan/Training/KendoTrainingGrid";
import { DisplayMsg } from "../../services/toastService";

export const loadClientNoteGridData = async (noteType, clientId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_NOTE.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_NOTE.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_NOTE.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_NOTE.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      noteType,
      entitySeqNum: clientId,
      APPUSER: sessionStorage.USER,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_CLIENT_NOTE.className
    }&action=${DEFAULT_GRID_INFO_CLIENT_NOTE.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } if (
      response?.status === false &&
      response?.Message ===
        "Collection was modified; enumeration operation may not execute."
    ) {
      // LoadData();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};

export const loadClientUserGridData = async (clientId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_USER.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_USER.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_USER.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_USER.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      entitySeqNum: clientId,
      APPUSER: sessionStorage.USER,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_CLIENT_USER.className
    }&action=${DEFAULT_GRID_INFO_CLIENT_USER.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};

// when we make a custom hook chnage entity and tns name from from Data to query string...

export const loadClientKioskGridData = async (entityId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_KIOSK.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_KIOSK.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_KIOSK.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_KIOSK.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("entityId", entityId);
    formData.append("TNSName", "PEHRDEV");
    const url = `${BASE_HANDLER_URL}?class=${DEFAULT_GRID_INFO_CLIENT_KIOSK.className}&action=${DEFAULT_GRID_INFO_CLIENT_KIOSK.action}`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } 
      DisplayMsg("2", response.Message);
      document.getElementById("loader").style.display = "none";
      return response;
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};

export const loadClientPatientFormGridData = async (entityId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ??
    DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("entityId", entityId);
    formData.append("TNSName", "PEHRDEV");
    const url = `${BASE_HANDLER_URL}?class=${DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.className}&action=${DEFAULT_GRID_INFO_CLIENT_PATIENT_FORM.action}`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } 
      DisplayMsg("2", response.Message);
      document.getElementById("loader").style.display = "none";
      return response;
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};

export const loadProjectPlanGridData = async (clientId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_TRAINING.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_TRAINING.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_TRAINING.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_TRAINING.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);

    const queryParams = new URLSearchParams({
      customerId: clientId,
      APPUSER: sessionStorage.USER,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_CLIENT_TRAINING.className
    }&action=${DEFAULT_GRID_INFO_CLIENT_TRAINING.action}&${
      queryParams ? `${queryParams}` : ""
    }`;

    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
